(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lg-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lg-discovery')) {
  customElements.define('lg-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const detail = event.target.closest('[data-lg-detail]');
        if (detail) {
          this.querySelectorAll('[data-lg-detail]').forEach(button => button.setAttribute('aria-pressed', String(button === detail)));
          this.querySelectorAll('[data-lg-panel]').forEach(panel => panel.hidden = panel.dataset.lgPanel !== detail.dataset.lgDetail);
        }
        const size = event.target.closest('[data-lg-size]');
        if (size) {
          this.dataset.activeSize = size.dataset.lgSize;
          this.querySelectorAll('[data-lg-size]').forEach(button => button.setAttribute('aria-pressed', String(button === size)));
          this.querySelectorAll('[data-lg-size-panel]').forEach(panel => panel.hidden = panel.dataset.lgSizePanel !== size.dataset.lgSize);
        }
        const zoom = event.target.closest('[data-lg-zoom]');
        const dialog = this.querySelector('dialog');
        if (zoom && typeof dialog.showModal === 'function') {
          event.preventDefault();
          const image = dialog.querySelector('img');
          image.src = zoom.href;
          image.alt = zoom.querySelector('img').alt;
          this.zoomTrigger = zoom;
          dialog.showModal();
        }
        if (event.target.closest('[data-lg-close]') || event.target === dialog) dialog.close();
      }, {signal:this.controller.signal});
      this.querySelector('dialog').addEventListener('close', () => this.zoomTrigger?.focus({preventScroll:true}), {signal:this.controller.signal});
      if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('lg-discovery__revealed'); this.observer.unobserve(entry.target); }
        }), {threshold:.12});
        this.querySelectorAll('[data-lg-reveal]').forEach(element => this.observer.observe(element));
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.bound = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-open-contact"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lg-open-contact')) {
  customElements.define('lg-open-contact', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.setupLeadTracking();
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-lg-enquiry-link]');
        if (!trigger || trigger.getAttribute('href') !== '#' + this.id) return;
        event.preventDefault();
        this.querySelector('h2').focus({ preventScroll: true });
        this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }, { signal: this.controller.signal });
      this.querySelector('[data-lg-open-chat]')?.addEventListener('click', (event) => {
        const opener = document.querySelector('.trigger-open-button.button-wrapper');
        const closer = document.querySelector('.trigger-close-button.button-wrapper');
        if (opener || closer) {
          event.preventDefault();
          if (opener) opener.click();
          requestAnimationFrame(() => document.querySelector('.channel-button.button-wrapper')?.focus());
        }
      }, { signal: this.controller.signal });
      requestAnimationFrame(() => {
        const feedback = this.querySelector('[role="status"], [role="alert"]');
        if (feedback) { feedback.focus({ preventScroll: true }); feedback.scrollIntoView({ block: 'center' }); }
      });
    }
    leadConsentAllowed() {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed?.() === true &&
        privacy?.marketingAllowed?.() === true &&
        privacy?.saleOfDataAllowed?.() === true;
    }
    loadLeadPrivacy(onReady) {
      const ready = () => {
        if (!this.isConnected) return;
        this.dataset.leadConsent = this.leadConsentAllowed() ? 'allowed' : 'not-allowed';
        onReady();
      };
      if (window.Shopify?.customerPrivacy) {
        ready();
        return;
      }
      this.dataset.leadConsent = 'loading';
      try {
        if (typeof window.Shopify?.loadFeatures !== 'function') {
          this.dataset.leadConsent = 'unavailable';
          return;
        }
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
          if (!this.isConnected) return;
          if (error || !window.Shopify?.customerPrivacy) {
            this.dataset.leadConsent = 'unavailable';
            return;
          }
          ready();
        });
      } catch (_) {
        this.dataset.leadConsent = 'unavailable';
      }
    }
    setupLeadTracking() {
      if (window.Shopify?.designMode) return;
      const form = this.querySelector('form');
      const productId = this.dataset.leadProduct;
      const pixelId = this.dataset.leadPixel;
      const enquiryKey = productId || (this.dataset.leadContext === 'home' ? 'home' : null);
      if (!form || !enquiryKey || !pixelId) return;
      const storageKey = 'lg-enquiry-attempt:' + enquiryKey;
      const success = this.querySelector('[data-lead-success]');

      if (!success) {
        // Only a new, valid submission can create a candidate Lead.
        try { sessionStorage.removeItem(storageKey); } catch (_) {}
        form.addEventListener('submit', () => {
          try {
            const returnField = form.querySelector('[name="return_to"]');
            sessionStorage.removeItem(storageKey);
            if (!returnField) return;
            const returnUrl = new URL(returnField.value, location.origin);
            returnUrl.searchParams.delete('lg_enquiry_id');
            returnField.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
            if (!form.checkValidity() || !this.leadConsentAllowed()) return;
            const id = crypto.randomUUID();
            returnUrl.searchParams.set('lg_enquiry_id', id);
            sessionStorage.setItem(storageKey, JSON.stringify({ id, createdAt: Date.now(), sent: false }));
            returnField.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
          } catch (_) {
            // Tracking must never interrupt the native Shopify/captcha submission.
          }
        }, { capture: true, signal: this.controller.signal });
        this.loadLeadPrivacy(() => {});
        document.addEventListener('visitorConsentCollected', () => {
          this.dataset.leadConsent = this.leadConsentAllowed() ? 'allowed' : 'not-allowed';
        }, { signal: this.controller.signal });
        return;
      }

      // Require Shopify's success output AND the matching submission in this tab.
      // A visit to a shared thank-you URL, or a refresh after sending, isn't a Lead.
      const confirmation = new URL(location.href).searchParams;
      let attempts = 0;
      const sendLead = () => {
        clearTimeout(this.leadTimer);
        if (!this.isConnected) return;
        try {
          const pending = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
          if (!pending || pending.sent ||
              confirmation.get('contact_posted') !== 'true' ||
              pending.id !== confirmation.get('lg_enquiry_id') ||
              typeof pending.createdAt !== 'number' ||
              Date.now() - pending.createdAt < 0 ||
              Date.now() - pending.createdAt > 30 * 60 * 1000) return;

          const pixel = window.fbq;
          if (this.leadConsentAllowed() && typeof pixel === 'function' &&
              typeof pixel.callMethod === 'function') {
            // Persist before dispatch to guard against refreshes and duplicate handlers.
            sessionStorage.setItem(storageKey, JSON.stringify({ ...pending, sent: true }));
            const leadContent = productId ? {
              content_name: 'Product enquiry',
              content_category: 'Artwork enquiry',
              content_ids: [productId],
              content_type: 'product_group'
            } : {
              content_name: 'Homepage enquiry',
              content_category: 'Artwork enquiry'
            };
            pixel('trackSingle', pixelId, 'Lead', leadContent, { eventID: 'lg-enquiry-' + pending.id });
            this.dataset.leadState = 'dispatched';
            return;
          }
          // Reuse the existing Shopify-managed pixel; never load or initialise a second one.
          if (++attempts < 60) this.leadTimer = setTimeout(sendLead, 500);
        } catch (_) {
          // If storage or tracking is unavailable, leave the successful enquiry intact.
        }
      };
      document.addEventListener('visitorConsentCollected', () => {
        this.dataset.leadConsent = this.leadConsentAllowed() ? 'allowed' : 'not-allowed';
        attempts = 0;
        sendLead();
      }, { signal: this.controller.signal });
      window.addEventListener('pageshow', sendLead, { signal: this.controller.signal });
      this.loadLeadPrivacy(sendLead);
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.leadTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-size-room"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lg-size-room')) {
  customElements.define('lg-size-room', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const buttons = [...this.querySelectorAll('button[data-size]')];
      const figures = [...this.querySelectorAll('[data-room]')];
      const panels = [...this.querySelectorAll('[data-details]')];
      const crop = this.querySelector('.lg-size-room__crop');
      const status = this.querySelector('[role="status"]');
      let request = 0;
      let currentSize;
      const show = size => {
        if (currentSize === size) return;
        currentSize = size;
        figures.forEach(figure => {
          const active = figure.dataset.room === size;
          figure.classList.toggle('is-active', active);
          figure.setAttribute('aria-hidden', String(!active));
          if (active) status.textContent = figure.querySelector('figcaption').textContent;
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.details !== size; });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.size === size)));
      };
      const sync = () => {
        if (!crop.clientWidth) return;
        const index = Math.max(0, Math.min(figures.length - 1, Math.round(crop.scrollLeft / crop.clientWidth)));
        show(figures[index].dataset.room);
      };
      const position = (size, behavior = 'instant') => {
        const index = figures.findIndex(figure => figure.dataset.room === size);
        if (index < 0) return;
        crop.scrollTo({ left: index * crop.clientWidth, behavior });
      };
      const select = async size => {
        const ticket = ++request;
        const target = figures.find(figure => figure.dataset.room === size);
        const image = target.querySelector('img');
        this.setAttribute('aria-busy', 'true');
        try {
          if (image) {
            image.loading = 'eager';
            if (!image.complete) await image.decode();
          }
        } catch (error) {
        } finally {
          if (ticket === request && !options.signal.aborted) {
            if (!image || image.naturalWidth > 0) {
              position(size, matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
            }
            this.removeAttribute('aria-busy');
          }
        }
      };
      this.querySelectorAll('.lg-size-room__view').forEach(link => {
        link.addEventListener('click', event => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (link.getAttribute('href') !== '#lg-product-ordering') return;
          const target = document.getElementById('lg-product-ordering');
          if (!target) return;
          event.preventDefault();
          target.focus({ preventScroll: true });
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        }, options);
      });
      this.classList.add('is-ready');
      show(this.dataset.initial);
      position(currentSize);
      crop.addEventListener('scroll', sync, { ...options, passive: true });
      crop.addEventListener('pointerdown', () => {
        ++request;
        this.removeAttribute('aria-busy');
        figures.forEach(figure => {
          const image = figure.querySelector('img');
          if (image) image.loading = 'eager';
        });
      }, { ...options, passive: true });
      let width = crop.clientWidth;
      this.resizeObserver = new ResizeObserver(() => {
        if (crop.clientWidth === width) return;
        width = crop.clientWidth;
        position(currentSize);
      });
      this.resizeObserver.observe(crop);
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(button.dataset.size), options);
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[next].focus();
          buttons[next].click();
        }, options);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('lg-cart-arrival')) {
    customElements.define('lg-cart-arrival', class extends HTMLElement {
      connectedCallback() {
        this.item = this.closest('.cart-item');
        const source = this.item?.querySelector('.desc');
        if (!source) return;

        this.observer = new MutationObserver(() => this.updateArrival());
        this.observer.observe(source, { childList: true, subtree: true, characterData: true });
        this.updateArrival();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      formatDate(value) {
        const date = value.replace(/\s+/g, ' ').trim();
        const match = date.match(/^(Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)\s+(\d{1,2})(?:,?\s+(\d{4}))?$/i);
        return match ? `${Number(match[2])} ${match[1]}${match[3] ? ` ${match[3]}` : ''}` : date;
      }

      updateArrival() {
        const widget = this.item.querySelector('.desc delivery-preview-widget');
        const from = widget?.querySelector('.essential-estimated-delivery-delivery_from')?.textContent.trim();
        const to = widget?.querySelector('.essential-estimated-delivery-delivery_to')?.textContent.trim();
        const ready = Boolean(from && to);
        this.item.classList.toggle('lg-cart-arrival-ready', ready);
        if (!ready) return;

        const dates = `${this.formatDate(from)} – ${this.formatDate(to)}`;
        const output = this.querySelector('strong');
        if (output.textContent !== dates) output.textContent = dates;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
